import React from 'react';
import BaseRowView from '../..';
import "./styles.css";
import { ImageAsset } from "res";

/**
 * @function PaymentView
 * @param {STRING} billerName - The Biller Name of the payment is passed through to the mainText of the BaseRowView.
 * @param {STRING} date - The date of the payment is passed through to the subText of the BaseRowView.
 * @param {STRING} amount - The amount of the payment is passed as a child to the BaseRowView.
 * @param {STRING} leftIcon - The ImageAsset of the payment is passed to the BaseRowView as the leftIcon.
 * @param {STRING} className - Additional classes to add to the PaymentView.
 * @return {React.Component}
 * @exported true
 * @description This is a component built using the BaseRowView that shows an overview for each payment.
 * @example
 * <PaymentView className="addedClass" leftIcon="NetflixIcon" billerName="Netflix" date="Sep 05, 2022" amount="+$12.99" />
 */
export default function PaymentView(props) {
  const billerName = props.billerName ?? "[Biller Name]";
  const leftIcon = props.leftIcon ?? "";
  const date = props.date ?? "[date]";
  const amount = props.amount ?? "[AMT]";
  const className = props.className ?? "";
  const point = props.dataPoint ?? "";
  const statusText = props.statusText ?? "";
  const statusClassName = props.statusClassName ?? "";
  
  return (
    <div className={className + " payment-view"}>
      <BaseRowView leftIcon={ <ImageAsset id={ leftIcon } className="left-icon" /> } mainText={ billerName } subText={ date } onClick={props.onClick} dataPoint={ point }><span className={statusClassName + " status-text hide"}>{statusText}</span><span className="amount-text">{ amount }</span></BaseRowView>
    </div>
  );
}